<template>
  <div class="page-content" style="padding-top: 4rem">
    <div class="container-fluid">
      <div class="row">
        <div class="col-lg-12">
          <div class="card" id="orderList">
            <div class="card-header border-0">
              <div class="d-flex align-items-center" style="text-align: left">
                <h5 class="card-title mb-0 flex-grow-1">All Cities</h5>
                <div class="flex-shrink-0">
                  <button
                    type="button"
                    class="btn btn-success add-btn"
                    @click="add('/add_city')"
                  >
                    <i class="ri-add-line align-bottom me-1"></i>
                    Add City
                  </button>
                  &nbsp;&nbsp;
                  <button
                    type="button"
                    class="btn btn-info"
                    @click="expCityData()"
                    fdprocessedid="1yahzs"
                  >
                    <i class="ri-download-line align-bottom me-1"></i> Export
                  </button>
                </div>
              </div>
            </div>
            <div
              class="card-body border border-dashed border-end-0 border-start-0"
            >
              <form>
                <div class="row g-3">
                  <div class="col-xxl-5 col-sm-6">
                    <div class="search-box">
                      <input
                        type="text"
                        class="form-control search"
                        placeholder="Enter City Name"
                        fdprocessedid="vrqiwe"
                        v-model="search_key"
                        @input="fetchList(1)"
                        @keydown.enter.prevent
                      />
                      <i class="ri-search-line search-icon"></i>
                    </div>
                  </div>

                  <div
                    class="col-xxl-2 col-sm-4"
                    v-if="ldata != null && ldata.role == 'superadmin'"
                  >
                    <div>
                      <select
                        class="form-control"
                        name="choices-single-default"
                        id="idStatus"
                        v-model="search_sort_by"
                        v-on:change="fetchList(1)"
                      >
                        <option value="" selected>Sort By</option>
                        <option
                          v-for="(option, index) in sortOptions"
                          :key="index"
                          :value="option.value"
                        >
                          {{ option.label }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
              </form>
            </div>
            <div class="card-body pt-0">
              <div class="mt-5">
                <div class="table-responsive table-card mb-1">
                  <div class="noresult" v-if="loading">
                    <rb-loading-table />
                  </div>
                  <div v-else>
                    <rb-data-table
                      :ldata="this.ldata"
                      :headers="headers"
                      :tableData="formattedCity"
                      @edit="updateCity"
                      @delete="openDeleteDialog"
                    />
                  </div>
                </div>
                <div class="d-flex justify-content-end" v-if="!loading">
                  <div
                    class="pagination-wrap hstack gap-2"
                    style="display: flex"
                  >
                    <div class="me-3">
                      <select
                        class="form-select w-auto"
                        v-model="limitProxy"
                        @change="getAdminList(1)"
                      >
                        <template
                          v-for="(role, index) in paginationOptions"
                          :key="index"
                        >
                          <option :value="role">{{ role }}</option>
                        </template>
                      </select>
                    </div>
                    <a
                      class="page-item pagination-prev px-4"
                      v-if="pageNo > 1"
                      @click="fetchList(pageNo - 1)"
                      href="javascript:void(0)"
                    >
                      <i class="ri-arrow-left-line"></i>
                    </a>
                    <ul
                      class="pagination listjs-pagination mb-0"
                      v-if="cities.length > 0"
                    >
                      <li class="active">
                        <a class="page" href="javascript:void(0)">{{
                          pageNo
                        }}</a>
                      </li>
                      <li>
                        <a
                          v-if="cities.length >= limit"
                          class="page"
                          href="javascript:void(0)"
                          @click="fetchList(pageNo + 1)"
                          >{{ pageNo + 1 }}</a
                        >
                      </li>
                    </ul>
                    <a
                      v-if="cities.length >= limit"
                      class="page-item pagination-next px-4"
                      href="javascript:void(0)"
                      @click="fetchList(pageNo + 1)"
                    >
                      <i class="ri-arrow-right-line"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <ToastNotification ref="toast" />
          <LoaderLoading v-if="overallLoading" />
          <DeleteDialog
            title="Delete City ?"
            ref="deleteDialog"
            @confirm="deleteCity"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getAllCities, getCityByID, deleteCity } from "@/apis/city";
import listMixin from "@/mixins/listMixin";

export default {
  name: "AppCityList",

  mixins: [listMixin],

  data() {
    return {
      cities: [],

      search_key: "",
      sortOptions: [
        { value: "Newest City", label: "Newest City" },
        {
          value: "opertors",
          label: "Operators Highest to Lowest",
        },
        { value: "Buses", label: "Buses Highest to Lowest" },
        { value: "Users", label: "Users Highest to Lowest" },
        {
          value: "Bookings",
          label: "Bookings Highest to Lowest",
        },
        {
          value: "Revenue",
          label: "Revenue Highest to Lowest",
        },
        {
          value: "Cancellations",
          label: "Cancellations Highest to Lowest",
        },
      ],

      headers: [
        {
          name: "City Name",
        },
        {
          name: "Created Date",
        },
        {
          name: "Status",
          auth: true,
        },
        {
          name: "Action",
          auth: true,
        },
      ],
    };
  },
  methods: {
    async expCityData() {
      const fields = ["name", "createdAt", "status"];
      this.$exportCsv(this.formattedCity, "City.csv", fields);
    },

    async fetchList(pageNo) {
      const response = await this.fetch(pageNo,getAllCities, {
        city_name: this.search_key,
      });
      this.cities = response.data;

      this.stopLoading()
    },

    async updateCity(city) {
      await this.update(getCityByID, city.spec_id, "/add_city");
    },

    async deleteCity(city) {
      await this.delete(deleteCity, city.spec_id);
    },
  },

  computed: {
    formattedCity() {
      return this.cities.map((city) => ({
        id: city.id,
        spec_id: city.city_id,
        name: city.city_name || "N/A",
        createdAt: city.created_at
          ? new Date(city.created_at).toLocaleString()
          : "N/A",
        status: city.is_active ? "Active" : "In Active",
      }));
    },
  },
};
</script>
